import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  background: ${(p) => p.theme.components};
  padding: 1rem 0;
  text-align: center;
  box-shadow: 0px -3px 3px -2px ${(p) => p.theme.accent.primary}45;
  margin-top: 4rem;

  @media screen and (max-width: 768px) {
    padding: 0.6rem 0;
    margin-top: 2rem;
  }
`;

export const TinyText = styled.p`
  font-size: 0.85rem;
  color: ${(p) => p.theme.accent.secondary};
  margin-top: ${(p) => (p.marginTop ? '0.2rem' : 0)};

  @media screen and (max-width: 768px) {
    font-size: 0.8rem;
  }
`;
